// export const getNewIntlRTTLegPrice = ({
//     originalPrice,
//     resultData,
//     legNumber
// }: {
//     originalPrice: number
//     resultData: any
//     legNumber: 0 | 1
// }) => {
//     const returnFlightLegNo = 1
//     const priceDownSortData = resultData?.sortData?.price_down?.[returnFlightLegNo]
//     const lowestPriceIndexStrOfReturnLegCard = priceDownSortData?.at(priceDownSortData?.length - 1)

//     const lowestPriceIndexOfReturnLegCard = lowestPriceIndexStrOfReturnLegCard?.split(':')?.[1]
//     const lowestPriceCardOfReturnFlights = resultData?.cards?.[returnFlightLegNo]?.[lowestPriceIndexOfReturnLegCard]
//     const lowestPrice = lowestPriceCardOfReturnFlights?.priceBreakup?.pr || 0
//     return legNumber === 0 ? originalPrice + lowestPrice : originalPrice - lowestPrice
// }

export const getTotalPriceForNewIntlRTT = (newIntlRTTSummeryDetails: Record<string, any>[]) => {
    const onwardObj = newIntlRTTSummeryDetails?.[0]
    const returnObj = newIntlRTTSummeryDetails?.[1]

    const onwardPr = onwardObj?.priceBreakup?.multiAirlinePrice || 0
    const returnPr = returnObj?.priceBreakup?.multiAirlinePrice || 0
    const totalPriceTwoLegs = onwardPr + returnPr

    const multiAirlinePriceWoDiscount = onwardObj?.priceBreakup?.multiAirlinePriceWoDiscount
    const totalMultiAirlinePriceWoDiscount = multiAirlinePriceWoDiscount
        ? multiAirlinePriceWoDiscount + returnPr
        : undefined

    const onwardRetailPrice = onwardObj?.priceBreakup?.pr || 0
    const returnRetailPrice = returnObj?.priceBreakup?.pr || 0
    const totalRetailPrice = onwardRetailPrice + returnRetailPrice

    return {
        totalPriceTwoLegs,
        totalStrikeOffPriceTwoLegs:
            totalRetailPrice > totalMultiAirlinePriceWoDiscount
                ? totalRetailPrice
                : totalMultiAirlinePriceWoDiscount > totalPriceTwoLegs
                  ? totalMultiAirlinePriceWoDiscount
                  : null
    }
}

/**
 * Compares SplRT and Retail prices for onward and return journeys and returns the cheapest for each.
 * @param {Array} newIntlRTTSummeryDetails - Array of journey objects (max 2: onward and return)
 * @param {Function} constructSplrt - Function to construct SplRT data
 * @returns {Object} Cheapest prices and their types for onward and return
 */

// export function getCheapestPriceBetweenSplRTAndRetail(newIntlRTTSummeryDetails: Record<string, any>[]) {
//     const onwardObj = newIntlRTTSummeryDetails?.[0]
//     const returnObj = newIntlRTTSummeryDetails?.[1]

//     const onwardPr = onwardObj?.priceBreakup?.pr || 0
//     const returnPr = returnObj?.priceBreakup?.pr || 0
//     const totalPr = onwardPr + returnPr

//     const onwardSplrtData =
//         onwardObj && returnObj ? constructSplrt(returnObj, onwardObj?.splRtFn) : ({} as Record<string, any>)
//     const returnSplrtData =
//         onwardObj && returnObj ? constructSplrt(onwardObj, returnObj?.splRtFn) : ({} as Record<string, any>)

//     const onwardSplrtFare = onwardSplrtData?.splrtFare
//     const returnSplrtFare = returnSplrtData?.splrtFare

//     if (onwardSplrtFare && returnSplrtFare) {
//         const totalSplrtFare = onwardSplrtFare + returnSplrtFare
//         if (totalSplrtFare < totalPr) {
//             return {
//                 onwardPrice: onwardSplrtFare,
//                 isSplRTPrice: true,
//                 returnPrice: returnSplrtFare,
//                 totalPrice: totalSplrtFare,
//                 strikeThroughPrice: totalPr
//             }
//         }
//         return {
//             onwardPrice: onwardPr,
//             isSplRTPrice: false,
//             returnPrice: returnPr,
//             totalPrice: totalPr,
//             strikeThroughPrice: null
//         }
//     }

//     return {
//         onwardPrice: onwardPr,
//         isSplRTPrice: false,
//         returnPrice: returnPr,
//         totalPrice: totalPr,
//         strikeThroughPrice: null
//     }
// }
